import { defineComponent } from 'vue'
import type { IEmptyStateProps } from './types'
import HomeIcon from 'assets/img/svg/icons/home.svg?url'
import IconContainer from '../icon-container'
import { tv } from 'tailwind-variants'

const ActionWrapperClass = tv({
  base: 'py-8',
  variants: {
    size: {
      s: 'py-2'
    }
  }
})

const EmptyStateClasses = tv({
  slots: {
    subtitle: 'text-gray-500 text-sm md:text-base',
  },
  variants: {
    subtitleAlign: {
      left: { subtitle: 'text-left' },
      center: { subtitle: 'text-center' },
      right: { subtitle: 'text-right' },
    },
  },
  defaultVariants: {
    subtitleAlign: 'left',
  },
})

const EmptyState = defineComponent<IEmptyStateProps>({
  setup(props: IEmptyStateProps, ctx) {
    const actionContent = computed(() => {
      const act = props.action;
      if (typeof act === 'function') return <act class="fill-gray-400"/>;
      return unref(act);
    })

    return () => {
      return (
        <div
          class="relative"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            height: '100%'
          }}
        >
          <div
            class="space-y-2"
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              flexWrap: 'wrap'
            }}
          >
            <IconContainer
              size="md"
              icon={props.icon ? props.icon : HomeIcon}
              iconBgClass="bg-gray-100 text-gray-400 mb-3"
              iconSize={props.iconSize}
              {...(props.iconContainer || {})}
            />
            {props.title && <h2 class="text-base md:text-lg font-semibold">{props.title}</h2>}
            {props.subtitle && (typeof props.subtitle === 'function' ? <props.subtitle/> : (
              <p class={EmptyStateClasses({ subtitleAlign:"center" }).subtitle()}>
                {props.subtitle}
              </p>
            ))}
            {props.body && unref(props.body)}
            {actionContent.value && (
              <div class={ActionWrapperClass({ size: props.size as any })}>
                { actionContent.value }
              </div>
            )}
            {ctx.slots.default ? ctx.slots.default() : null}
          </div>
        </div>
      )
    }
  }
})

EmptyState.props = ['title', 'subtitle', 'action', 'icon', 'iconContainer', 'size', 'body', 'subtitleAlign']

export default EmptyState
